(() => {
  const initGallery = (gallery) => {
    if (gallery.dataset.somarSliderReady === 'true') return;
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const list = gallery.querySelector('[id^="Slider-Gallery"]');
    if (!viewer || !list) return;
    const slides = Array.from(list.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    gallery.dataset.somarSliderReady = 'true';
    const controls = document.createElement('div');
    controls.className = 'somar-gallery-slider';
    controls.setAttribute('aria-label', 'Product image slider');

    const setActive = (index) => {
      controls.querySelectorAll('[data-somar-media-dot]').forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'somar-gallery-slider__dot' + (index === 0 ? ' is-active' : '');
      dot.dataset.somarMediaDot = '';
      dot.setAttribute('aria-label', 'Show product image ' + (index + 1));
      if (index === 0) dot.setAttribute('aria-current', 'true');
      dot.innerHTML = '<span></span>';
      dot.addEventListener('click', () => {
        const left = slide.offsetLeft - list.offsetLeft - (list.clientWidth - slide.clientWidth) / 2;
        list.scrollTo({ left, behavior: 'smooth' });
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        setActive(index);
      });
      controls.appendChild(dot);
    });

    viewer.appendChild(controls);

    viewer.addEventListener('slideChanged', (event) => {
      const index = slides.indexOf(event.detail.currentElement);
      if (index >= 0) setActive(index);
    });

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      const index = slides.indexOf(visible.target);
      if (index >= 0) setActive(index);
    }, { root: list, threshold: [0.5, 0.75] });

    slides.forEach((slide) => observer.observe(slide));
  };

  const init = () => document.querySelectorAll('media-gallery').forEach(initGallery);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
